<template>
  <el-dialog width="1000px" :close-on-click-modal="false"  :visible="visible" @close="close">
    <div slot="title" >
      <div   class="mr20">
        <span class="mr10" style="font-size:18px"> {{ title }}</span> <span class="blue">{{ goodsName }} </span>
      </div>
      
    </div>
    <div>
      <div class="blue pointer" @click="show = !show">
        展开计算
        <span class="el-icon-arrow-right" :class="{ rotate: show }"></span>
      </div>
      <transition name="el-zoom-in-top">
        <div class="calculate p20 mt10" v-if="show">
          单件商品总量
          <el-input
            clearable
            style="width: 100px"
            v-model.trim="goodsTotalNum"
            size="small"
            @mousewheel.prevent.native
            @input="filterGt0OrFixed0('goodsTotalNum')"
            class="ipt mr10"
          >
          </el-input>
          每
          <el-input
            clearable
            style="width: 100px"
            v-model.trim="today"
            size="small"
            @mousewheel.prevent.native
            @input="filterGt0OrFixed0('today')"
            class="ipt"
          >
          </el-input>
          天单品使用量
          <el-input
            clearable
            style="width: 100px"
            v-model.trim="todayNum"
            size="small"
            @mousewheel.prevent.native
            @input="filterGt0OrFixed0('todayNum')"
            class="ipt mr10"
          >
          </el-input>
          <el-button
            size="small"
            type="warning"
            @click="calculate"
            :disabled="!goodsTotalNum || !today || !todayNum"
            >计算</el-button
          >
          <div class="form-item-tip">计算器没有单位限制，可计算奶粉、纸尿布等任何商品，例如总量1200,每2天可以吃150，填写后点击计算</div>
        </div>
      </transition>
      <div class="mt20">
        每个单品可以使用
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="repurchaseCycleNum"
          size="small"
          @mousewheel.prevent.native
          @input="filterGt0OrFixed0('repurchaseCycleNum')"
          class="ipt mr10"
        >
        </el-input>
        天
        <div class="form-item-tip">例如：每罐可以使用7天，只能填写整数</div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer flex flex-center">
      <el-button size="small" type="primary" @click="confirm">确 定</el-button>
      <el-button size="small" @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    goodsName: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    enabelList: {
      type: Array,
      default: () => []
    }
  },
  components: {},
  data() {
    return {
      today: "",
      todayNum: "",
      goodsTotalNum: "",
      show: false,
      repurchaseCycleNum: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    calculate() {
      let num = this.goodsTotalNum / (this.todayNum / this.today);
      if (num >= 1) {
        this.repurchaseCycleNum = Math.floor(num) ? Math.floor(num) : "";
      } else {
        this.$message({
          message: "单品使用天数需>=1，请重新计算",
          type: "warning"
        });
      }
    },
    filterGt0OrFixed0(prop) {
      this[prop] = this[prop].replace(/^(0+)/, ""); //过滤0开头
      this[prop] = this[prop].replace(/^(0+)|[^\d]+/g, "");
      this[prop] = this[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    confirm() {
      if (this.repurchaseCycleNum) {
        this.$emit("confirm", this.repurchaseCycleNum);
      } else {
        this.$message({
          message: "请填写复购周期",
          type: "warning"
        });
      }
    },

    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang='scss' scoped>
.calculate {
  box-shadow: 0px 0px 12px 0px rgba(221, 221, 221, 0.6);
}
.el-icon-arrow-right {
  &.rotate {
    transform: rotate(90deg);
    transition: transform 200ms ease-in-out;
  }
}
</style>
